// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"ProductColorsList_contentComponent__37nH_","tableContainer":"ProductColorsList_tableContainer__18wyF"};